{
  "exc.dtc.files.v1.FileRequest_one": "File Request",
  "exc.dtc.files.v1.FileRequest_other": "File Requests",
  "exc.dtc.files.v1.File_one": "File",
  "exc.dtc.files.v1.File_other": "Files",
  "exc.dtcc.utc.v1.UtcFixSession_one": "UTC FIX Session",
  "exc.dtcc.utc.v1.UtcFixSession_other": "UTC FIX Sessions",
  "exc.ice.corpactions.v1.Action_one": "Action",
  "exc.ice.corpactions.v1.Action_other": "Actions",
  "exc.ice.gsm.v1.Instrument_one": "Instrument",
  "exc.ice.gsm.v1.Instrument_other": "Instruments",
  "exc.ice.job.v1.Job_one": "Job",
  "exc.ice.job.v1.Job_other": "Jobs",
  "exc.ice.job.v1.Task_one": "Task",
  "exc.ice.job.v1.Task_other": "Tasks",
  "exc.increase.v1.AccountNumber_one": "Account Number",
  "exc.increase.v1.AccountNumber_other": "Account Numbers",
  "exc.increase.v1.Ach_one": "ACH",
  "exc.increase.v1.Ach_other": "ACHES",
  "exc.increase.v1.Wire_one": "Wire",
  "exc.increase.v1.Wire_other": "Wires",
  "exc.jane_street.v1.PfofJob_one": "PFOF Job",
  "exc.jane_street.v1.PfofJob_other": "PFOF Jobs",
  "exc.jpmam.v1.Destination_one": "Destination",
  "exc.jpmam.v1.Destination_other": "Destinations",
  "exc.jpmam.v1.JpmamJob_one": "JPMAM Job",
  "exc.jpmam.v1.JpmamJob_other": "JPMAM Jobs",
  "exc.jpmam.v1.JpmamOrder_one": "JPMAM Order",
  "exc.jpmam.v1.JpmamOrder_other": "JPMAM Orders",
  "exc.jpmam.v1.JpmamTask_one": "JPMAM Task",
  "exc.jpmam.v1.JpmamTask_other": "JPMAM Tasks",
  "exc.jpmam.v1.NetOrder_one": "Net Order",
  "exc.jpmam.v1.NetOrder_other": "Net Orders",
  "exc.plaid.v1.ProcessorToken_one": "Processor Token",
  "exc.plaid.v1.ProcessorToken_other": "Processor Tokens",
  "exc.quotemedia.v1.EodPriceJob_one": "EOD Price Job",
  "exc.quotemedia.v1.EodPriceJob_other": "EOD Price Jobs",
  "exc.quotemedia.v1.EodPriceTask_one": "EOD Price Task",
  "exc.quotemedia.v1.EodPriceTask_other": "EOD Price Tasks",
  "exc.quotemedia.v1.Sp_500List_one": "S&P 500 List",
  "exc.quotemedia.v1.Sp_500List_other": "S&P 500 Lists",
  "exc.route.v1.FixMessage_one": "FIX Message",
  "exc.route.v1.FixMessage_other": "FIX Messages",
  "exc.route.v1.FixOrder_one": "FIX Order",
  "exc.route.v1.FixOrder_other": "FIX Orders",
  "exc.route.v1.FixSession_one": "FIX Session",
  "exc.route.v1.FixSession_other": "FIX Sessions",
  "exc.route.v1.RoutingRule_one": "Routing Rule",
  "exc.route.v1.RoutingRule_other": "Routing Rules",
  "exf.ofac.emulator.v1.OfacEmulator_one": "OFAC Emulator",
  "exf.ofac.emulator.v1.OfacEmulator_other": "OFAC Emulators",
  "ixc.assets.clearing.v1.MoneyMarketInternalStats_one": "Money Market Internal Stats",
  "ixc.assets.clearing.v1.MoneyMarketInternalStats_other": "Money Market Internal Stats",
  "ixc.assets.v1.AssetException_one": "Asset Exception",
  "ixc.assets.v1.AssetException_other": "Asset Exceptions",
  "ixc.assets.v1.Asset_one": "Asset",
  "ixc.assets.v1.Asset_other": "Assets",
  "ixc.assets.v1.EodPrice_one": "EOD Price",
  "ixc.assets.v1.EodPrice_other": "EOD Prices",
  "ixc.assets.v1.MoneyMarketStats_one": "Money Market Stats",
  "ixc.assets.v1.MoneyMarketStats_other": "Money Market Stats",
  "ixc.billing.v1.Charge_one": "Charge",
  "ixc.billing.v1.Charge_other": "Charges",
  "ixc.cases.v1.Case_one": "Case",
  "ixc.cases.v1.Case_other": "Cases",
  "ixc.clearing.v1.ClosingPosition_one": "Closing Position",
  "ixc.clearing.v1.ClosingPosition_other": "Closing Positions",
  "ixc.corpactions.caadmin.v1.Action_one": "Action",
  "ixc.corpactions.caadmin.v1.Action_other": "Actions",
  "ixc.corpactions.caadmin.v1.Payment_one": "Payment",
  "ixc.corpactions.caadmin.v1.Payment_other": "Payments",
  "ixc.costbasis.v1.Realization_one": "Realization",
  "ixc.costbasis.v1.Realization_other": "Realizations",
  "ixc.costbasis.v1.TaxLot_one": "Tax Lot",
  "ixc.costbasis.v1.TaxLot_other": "Tax Lots",
  "ixc.dtcc.cns.v1.AssetDay_one": "Asset Day",
  "ixc.dtcc.cns.v1.AssetDay_other": "Asset Days",
  "ixc.dtcc.dreco.v1.Asset_one": "Asset",
  "ixc.dtcc.dreco.v1.Asset_other": "Assets",
  "ixc.dtcc.dtc.v1.AssetDay_one": "Asset Day",
  "ixc.dtcc.dtc.v1.AssetDay_other": "Asset Days",
  "ixc.fees.v1.FeeRate_one": "Fee Rate",
  "ixc.fees.v1.FeeRate_other": "Fee Rates",
  "ixc.funding.v1.AccountNumber_one": "Account Number",
  "ixc.funding.v1.AccountNumber_other": "Account Numbers",
  "ixc.funding.v1.BatchAllocation_one": "Batch Allocation",
  "ixc.funding.v1.BatchAllocation_other": "Batch Allocations",
  "ixc.funding.v1.BatchTransfer_one": "Batch Transfer",
  "ixc.funding.v1.BatchTransfer_other": "Batch Transfers",
  "ixc.funding.v1.Source_one": "Source",
  "ixc.funding.v1.Source_other": "Sources",
  "ixc.funding.v1.Transfer_one": "Transfer",
  "ixc.funding.v1.Transfer_other": "Transfers",
  "ixc.generate.v1.MonthlyStatementsJob_one": "Monthly Statements Job",
  "ixc.generate.v1.MonthlyStatementsJob_other": "Monthly Statements Jobs",
  "ixc.generate.v1.MonthlyStatementsTask_one": "Monthly Statements Task",
  "ixc.generate.v1.MonthlyStatementsTask_other": "Monthly Statements Tasks",
  "ixc.generate.v1.TradeConfirmationsJob_one": "Trade Confirmations Job",
  "ixc.generate.v1.TradeConfirmationsJob_other": "Trade Confirmations Jobs",
  "ixc.generate.v1.TradeConfirmationsTask_one": "Trade Confirmations Task",
  "ixc.generate.v1.TradeConfirmationsTask_other": "Trade Confirmations Tasks",
  "ixc.inventory.v1.BooksOrder_one": "Books Order",
  "ixc.inventory.v1.BooksOrder_other": "Books Orders",
  "ixc.inventory.v1.FirmOrder_one": "Firm Order",
  "ixc.inventory.v1.FirmOrder_other": "Firm Orders",
  "ixc.inventory.v1.SecurityDay_one": "Security Day",
  "ixc.inventory.v1.SecurityDay_other": "Security Days",
  "ixc.inventory.v1.TradingDay_one": "Trading Day",
  "ixc.inventory.v1.TradingDay_other": "Trading Days",
  "ixc.mfreco.v1.PositionDay_one": "Position Day",
  "ixc.mfreco.v1.PositionDay_other": "Position Days",
  "ixc.mutualfunds.v1.DividendAccrual_one": "Dividend Accrual",
  "ixc.mutualfunds.v1.DividendAccrual_other": "Dividend Accruals",
  "ixc.mutualfunds.v1.FundOrder_one": "Fund Order",
  "ixc.mutualfunds.v1.FundOrder_other": "Fund Orders",
  "ixc.mutualfunds.v1.MutualFundsJob_one": "Mutual Funds Job",
  "ixc.mutualfunds.v1.MutualFundsJob_other": "Mutual Funds Jobs",
  "ixc.mutualfunds.v1.MutualFundsTask_one": "Mutual Funds Task",
  "ixc.mutualfunds.v1.MutualFundsTask_other": "Mutual Funds Tasks",
  "ixc.mutualfunds.v1.VenueOrder_one": "Venue Order",
  "ixc.mutualfunds.v1.VenueOrder_other": "Venue Orders",
  "ixc.orders.v1.BatchAllocation_one": "Batch Allocation",
  "ixc.orders.v1.BatchAllocation_other": "Batch Allocations",
  "ixc.orders.v1.BatchOrder_one": "Batch Order",
  "ixc.orders.v1.BatchOrder_other": "Batch Orders",
  "ixc.orders.v1.Order_one": "Order",
  "ixc.orders.v1.Order_other": "Orders",
  "ixc.payments.v1.AccountNumber_one": "Account Number",
  "ixc.payments.v1.AccountNumber_other": "Account Numbers",
  "ixc.payments.v1.Ach_one": "ACH",
  "ixc.payments.v1.Ach_other": "ACHES",
  "ixc.payments.v1.IncomingAch_one": "Incoming ACH",
  "ixc.payments.v1.IncomingAch_other": "Incoming ACHs",
  "ixc.payments.v1.IncomingWire_one": "Incoming Wire",
  "ixc.payments.v1.IncomingWire_other": "Incoming Wires",
  "ixc.payments.v1.Wire_one": "Wire",
  "ixc.payments.v1.Wire_other": "Wires",
  "ixc.portfolio.v1.AssetBalance_one": "Asset Balance",
  "ixc.portfolio.v1.AssetBalance_other": "Asset Balances",
  "ixc.portfolio.v1.BalanceSnapshot_one": "Balance Snapshot",
  "ixc.portfolio.v1.BalanceSnapshot_other": "Balance Snapshots",
  "ixc.portfolio.v1.CashBalance_one": "Cash Balance",
  "ixc.portfolio.v1.CashBalance_other": "Cash Balances",
  "ixc.portfolio.v1.DepositAdvance_one": "Deposit Advance",
  "ixc.portfolio.v1.DepositAdvance_other": "Deposit Advances",
  "ixc.portfolio.v1.Hold_one": "Hold",
  "ixc.portfolio.v1.Hold_other": "Holds",
  "ixc.portfolio.v1.SweepBalance_one": "Sweep Balance",
  "ixc.portfolio.v1.SweepBalance_other": "Sweep Balances",
  "ixc.portfolio.v1.Transaction_one": "Transaction",
  "ixc.portfolio.v1.Transaction_other": "Transactions",
  "ixc.prospectus.v1.ProspectusJob_one": "Prospectus Job",
  "ixc.prospectus.v1.ProspectusJob_other": "Prospectus Jobs",
  "ixc.prospectus.v1.ProspectusTask_one": "Prospectus Task",
  "ixc.prospectus.v1.ProspectusTask_other": "Prospectus Tasks",
  "ixc.proxyvote.v1.ProxyJob_one": "Proxy Job",
  "ixc.proxyvote.v1.ProxyJob_other": "Proxy Jobs",
  "ixc.proxyvote.v1.ProxyTask_one": "Proxy Task",
  "ixc.proxyvote.v1.ProxyTask_other": "Proxy Tasks",
  "ixc.ragl.v1.ManualEntry_one": "Manual Entry",
  "ixc.ragl.v1.ManualEntry_other": "Manual Entries",
  "ixc.ragl.v1.Transaction_one": "Transaction",
  "ixc.ragl.v1.Transaction_other": "Transactions",
  "ixc.registration.v1.Account_one": "Account",
  "ixc.registration.v1.Account_other": "Accounts",
  "ixc.registration.v1.Principal_one": "Principal",
  "ixc.registration.v1.Principal_other": "Principals",
  "ixc.registration.v1.ProfileVersion_one": "Profile Version",
  "ixc.registration.v1.ProfileVersion_other": "Profile Versions",
  "ixc.registration.v1.Profile_one": "Profile",
  "ixc.registration.v1.Profile_other": "Profiles",
  "ixc.sweeps.clearing.v1.SweepOrder_one": "Sweep Order",
  "ixc.sweeps.clearing.v1.SweepOrder_other": "Sweep Orders",
  "ixc.sweeps.clearing.v1.SweepParticipantStats_one": "Sweep Participant Stats",
  "ixc.sweeps.clearing.v1.SweepParticipantStats_other": "Sweep Participant Stats",
  "ixc.sweeps.clearing.v1.SweepParticipant_one": "Sweep Participant",
  "ixc.sweeps.clearing.v1.SweepParticipant_other": "Sweep Participants",
  "ixc.sweeps.clearing.v1.SweepTargetStats_one": "Sweep Target Stats",
  "ixc.sweeps.clearing.v1.SweepTargetStats_other": "Sweep Target Stats",
  "ixc.sweeps.clearing.v1.SweepsJob_one": "Sweeps Job",
  "ixc.sweeps.clearing.v1.SweepsJob_other": "Sweeps Jobs",
  "ixc.sweeps.clearing.v1.SweepsTask_one": "Sweeps Task",
  "ixc.sweeps.clearing.v1.SweepsTask_other": "Sweeps Tasks",
  "ixc.sweeps.v1.SweepPlan_one": "Sweep Plan",
  "ixc.sweeps.v1.SweepPlan_other": "Sweep Plans",
  "ixc.sweeps.v1.SweepTarget_one": "Sweep Target",
  "ixc.sweeps.v1.SweepTarget_other": "Sweep Targets",
  "ixc.trade.v1.Trade_one": "Trade",
  "ixc.trade.v1.Trade_other": "Trades",
  "ixc.tradereporting.v1.BlueSheet_one": "Blue Sheet",
  "ixc.tradereporting.v1.BlueSheet_other": "Blue Sheets",
  "ixc.tradereporting.v1.CaisReport_one": "CAIS Report",
  "ixc.tradereporting.v1.CaisReport_other": "CAIS Reports",
  "ixc.tradereporting.v1.CatReport_one": "CAT Report",
  "ixc.tradereporting.v1.CatReport_other": "CAT Reports",
  "ixc.tradereporting.v1.Sec_606AReport_one": "SEC 606(a) Report",
  "ixc.tradereporting.v1.Sec_606AReport_other": "SEC 606(a) Reports",
  "ixc.trf.v1.TrfReport_one": "TRF Report",
  "ixc.trf.v1.TrfReport_other": "TRF Reports",
  "ixc.trf.v1.TrfSession_one": "TRF Session",
  "ixc.trf.v1.TrfSession_other": "TRF Sessions",
  "ixf.accounting.v1.Account_one": "Account",
  "ixf.accounting.v1.Account_other": "Accounts",
  "ixf.accounting.v1.Config_one": "Config",
  "ixf.accounting.v1.Config_other": "Configs",
  "ixf.accounting.v1.ManualEntry_one": "Manual Entry",
  "ixf.accounting.v1.ManualEntry_other": "Manual Entries",
  "ixf.accounting.v1.Transaction_one": "Transaction",
  "ixf.accounting.v1.Transaction_other": "Transactions",
  "ixf.documents.v1.Document_one": "Document",
  "ixf.documents.v1.Document_other": "Documents",
  "ixf.hours.v1.Exception_one": "Exception",
  "ixf.hours.v1.Exception_other": "Exceptions",
  "ixf.hours.v1.MoneyMarketScheduleVersion_one": "Money Market Schedule Version",
  "ixf.hours.v1.MoneyMarketScheduleVersion_other": "Money Market Schedule Versions",
  "ixf.hours.v1.MoneyMarketSchedule_one": "Money Market Schedule",
  "ixf.hours.v1.MoneyMarketSchedule_other": "Money Market Schedules",
  "ixf.hours.v1.TradingScheduleVersion_one": "Trading Schedule Version",
  "ixf.hours.v1.TradingScheduleVersion_other": "Trading Schedule Versions",
  "ixf.hours.v1.TradingSchedule_one": "Trading Schedule",
  "ixf.hours.v1.TradingSchedule_other": "Trading Schedules",
  "ixf.hours.v1.TransfersScheduleVersion_one": "Transfers Schedule Version",
  "ixf.hours.v1.TransfersScheduleVersion_other": "Transfers Schedule Versions",
  "ixf.hours.v1.TransfersSchedule_one": "Transfers Schedule",
  "ixf.hours.v1.TransfersSchedule_other": "Transfers Schedules",
  "ixf.reports.v1.Report_one": "Report",
  "ixf.reports.v1.Report_other": "Reports",
  "ixf.watchlist.v1.Fincen_314Entry_one": "FinCEN 314 Entry",
  "ixf.watchlist.v1.Fincen_314Entry_other": "FinCEN 314 Entries",
  "ixf.watchlist.v1.Fincen_314File_one": "FinCEN 314 File",
  "ixf.watchlist.v1.Fincen_314File_other": "FinCEN 314 Files",
  "ixf.watchlist.v1.Fincen_314Match_one": "FinCEN 314 Match",
  "ixf.watchlist.v1.Fincen_314Match_other": "FinCEN 314 Matches",
  "ixf.watchlist.v1.OfacFile_one": "OFAC File",
  "ixf.watchlist.v1.OfacFile_other": "OFAC Files",
  "ixf.watchlist.v1.OfacMatch_one": "OFAC Match",
  "ixf.watchlist.v1.OfacMatch_other": "OFAC Matches",
  "ixf.watchlist.v1.OfacSdn_one": "OFAC SDN",
  "ixf.watchlist.v1.OfacSdn_other": "OFAC SDNS",
  "ixm.agentauth.v1.AgentKey_one": "Agent Key",
  "ixm.agentauth.v1.AgentKey_other": "Agent Keys",
  "ixm.auth.v1.ApiKey_one": "API Key",
  "ixm.auth.v1.ApiKey_other": "API Keys",
  "ixm.events.v1.Target_one": "Target",
  "ixm.events.v1.Target_other": "Targets",
  "ixm.trigger.v1.Trigger_one": "Trigger",
  "ixm.trigger.v1.Trigger_other": "Triggers",
  "ixm.userauth.v1.AccessRequest_one": "Access Request",
  "ixm.userauth.v1.AccessRequest_other": "Access Requests",
  "ixm.userauth.v1.Artifact_one": "Artifact",
  "ixm.userauth.v1.Artifact_other": "Artifacts",
  "ixm.userauth.v1.BrandingVersion_one": "Branding Version",
  "ixm.userauth.v1.BrandingVersion_other": "Branding Versions",
  "ixm.userauth.v1.OrganizationMemberInvitation_one": "Organization Member Invitation",
  "ixm.userauth.v1.OrganizationMemberInvitation_other": "Organization Member Invitations",
  "ixm.userauth.v1.OrganizationMember_one": "Organization Member",
  "ixm.userauth.v1.OrganizationMember_other": "Organization Members",
  "ixm.userauth.v1.Organization_one": "Organization",
  "ixm.userauth.v1.Organization_other": "Organizations",
  "ixm.userauth.v1.Program_one": "Program",
  "ixm.userauth.v1.Program_other": "Programs",
  "ixm.userauth.v1.RealmAccess_one": "Realm Access",
  "ixm.userauth.v1.RealmAccess_other": "Realm Accesses",
  "ixm.userauth.v1.Realm_one": "Realm",
  "ixm.userauth.v1.Realm_other": "Realms",
  "ixm.userauth.v1.Role_one": "Role",
  "ixm.userauth.v1.Role_other": "Roles",
  "ixm.userauth.v1.Tenant_one": "Tenant",
  "ixm.userauth.v1.Tenant_other": "Tenants",
  "ixm.userauth.v1.UserSession_one": "User Session",
  "ixm.userauth.v1.UserSession_other": "User Sessions",
  "ixm.userauth.v1.User_one": "User",
  "ixm.userauth.v1.User_other": "Users",
  "ixt.builds.v1.Repo_one": "Repo",
  "ixt.builds.v1.Repo_other": "Repos",
  "ixt.e2e.v1.TestRun_one": "Test Run",
  "ixt.e2e.v1.TestRun_other": "Test Runs",
  "j5.registry.v1.Artifact_one": "Artifact",
  "j5.registry.v1.Artifact_other": "Artifacts",
  "o5.aws.deployer.v1.Cluster_one": "Cluster",
  "o5.aws.deployer.v1.Cluster_other": "Clusters",
  "o5.aws.deployer.v1.Deployment_one": "Deployment",
  "o5.aws.deployer.v1.Deployment_other": "Deployments",
  "o5.aws.deployer.v1.Environment_one": "Environment",
  "o5.aws.deployer.v1.Environment_other": "Environments",
  "o5.aws.deployer.v1.Stack_one": "Stack",
  "o5.aws.deployer.v1.Stack_other": "Stacks",
  "o5.dante.v1.DeadMessage_one": "Dead Message",
  "o5.dante.v1.DeadMessage_other": "Dead Messages"
}
